import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { ILargeMailingState, LargeMailingState } from './states.store';
import { PropertyServices, DemandServices, PersonServices } from '../../../services';
import { ReportServices } from '../../../services/report.services';

/** SEND MESSAGE CHILD component */
import largeMailingActions from './actions.store';
import largeMailingGetters from './getters.store';
import largeMailingMutations from './mutations.store';

/** define module */
export class LargeMailingModule<RootState> implements Module<ILargeMailingState, RootState>{
  namespaced: boolean;
  state: ILargeMailingState;
  getters: GetterTree<ILargeMailingState, RootState>;
  actions: ActionTree<ILargeMailingState, RootState>;
  mutations: MutationTree<ILargeMailingState>;
  /**
   *
   */
  constructor() {
    this.namespaced = true;
    this.state = new LargeMailingState({ service: new ReportServices, propertyService: new PropertyServices, demandService: new DemandServices, personService: new PersonServices});

    this.mutations = {
      ...largeMailingMutations,
    };

    this.actions = {
      ...largeMailingActions,
    };

    this.getters = {
      ...largeMailingGetters,
    };
  }
}
